<template>
  <header class="Header" ref="headerEl">
    <div class="auto">
      <div class="Logo">
        <a href='/'>
          <img src="static/picture/logo_black_eng.png" class="caise">
          <img src="static/picture/logo_weight_eng.png" class="white">
        </a>
      </div>
      <div class="MainNav" id="menuall" :class="{ on: mobileMenuOpen }">
        <ul>
          <li id="nav0">
            <span>
              <div>
                <a href='/'>{{ $t('nav.home') }}</a>
              </div>
            </span>
          </li>
          <li id="nav1" class="nava"
            :class="{ onnav: navHoverIndex === 1 }"
            @mouseenter="onNavHover(1)" @mouseleave="onNavLeave">
            <span><a href='/TechnicalList'>{{ $t('nav.techTitle') }}</a><em class="arr" @click.prevent="toggleMobileNav(1)"><i class="iconfont iconxjt"></i></em></span>
            <div class="NavPulls" :class="{ open: mobileNavOpen === 1 }">
              <dl>
                <dd><a href='/Technical1'>{{ $t('nav.tech.biomimetic') }}</a></dd>
                <dd><a href='/Technical2'>{{ $t('nav.tech.micelle') }}</a></dd>
                <dd><a href='/Technical3'>{{ $t('nav.tech.conjugate') }}</a></dd>
                <dd><a href='/Technical4'>{{ $t('nav.tech.fluorescent') }}</a></dd>
              </dl>
            </div>
          </li>
          <li id="nav2" class="nava"
            :class="{ onnav: navHoverIndex === 2 }"
            @mouseenter="onNavHover(2)" @mouseleave="onNavLeave">
            <span><a href='/LayList'>{{ $t('nav.productsTitle') }}</a><em class="arr" @click.prevent="toggleMobileNav(2)"><i class="iconfont iconxjt"></i></em></span>
            <div class="NavPulls" :class="{ open: mobileNavOpen === 2 }">
              <dl>
                <dd><a href='/LayList?product=1'>{{ $t('nav.products.dye') }}</a></dd>
                <dd><a href='/LayList?product=2'>{{ $t('nav.products.ortho') }}</a></dd>
                <dd><a href='/LayList?product=3'>{{ $t('nav.products.lipid') }}</a></dd>
                <dd><a href='/LayList?product=4'>{{ $t('nav.products.degradable') }}</a></dd>
                <dd><a href='/LayList?product=11'>{{ $t('nav.products.microsphere') }}</a></dd>
                <dd><a href='/LayList?product=13'>{{ $t('nav.products.liposome') }}</a></dd>
                <dd><a href='/LayList?product=15'>{{ $t('nav.products.hydrogel') }}</a></dd>
              </dl>
            </div>
          </li>
          <li id="nav3" class="nava"
            :class="{ onnav: navHoverIndex === 3 }"
            @mouseenter="onNavHover(3)" @mouseleave="onNavLeave">
            <span><a href='/TechnicalService'>{{ $t('nav.serviceTitle') }}</a><em class="arr" @click.prevent="toggleMobileNav(3)"><i class="iconfont iconxjt"></i></em></span>
            <div class="NavPulls" :class="{ open: mobileNavOpen === 3 }">
              <dl>
                <dd><a href="javascript:void(0)">{{ $t('nav.service.synthesis') }}</a></dd>
                <dd><a href="javascript:void(0)">{{ $t('nav.service.nanoAssembly') }}</a></dd>
                <dd><a href="javascript:void(0)">{{ $t('nav.service.bioImaging') }}</a></dd>
                <dd><a href="javascript:void(0)">{{ $t('nav.service.multiMode') }}</a></dd>
                <dd><a href="javascript:void(0)">{{ $t('nav.service.structureAnalysis') }}</a></dd>
              </dl>
            </div>
          </li>

          <li id="nav4" class="nava"
            :class="{ onnav: navHoverIndex === 4 }"
            @mouseenter="onNavHover(4)" @mouseleave="onNavLeave">
            <span><a href='/DownList'>{{ $t('nav.downloadsTitle') }}</a><em class="arr" @click.prevent="toggleMobileNav(4)"><i class="iconfont iconxjt"></i></em></span>
            <div class="NavPulls" :class="{ open: mobileNavOpen === 4 }">
              <dl>
                <dd><a href='/DownList'>{{ $t('nav.downloads.sciInfo') }}</a></dd>
              </dl>
            </div>
          </li>

          <li id="nav5" class="nava"
            :class="{ onnav: navHoverIndex === 5 }"
            @mouseenter="onNavHover(5)" @mouseleave="onNavLeave">
            <span><a href='/NewsCenter'>{{ $t('nav.news') }}</a><em class="arr"><i class="iconfont iconxjt"></i></em></span>
            <div class="NavPulls">
            </div>
          </li>


          <li id="nav6" class="nava"
            :class="{ onnav: navHoverIndex === 6 }"
            @mouseenter="onNavHover(6)" @mouseleave="onNavLeave">
            <span>
              <div>
                <a href='/AboutWe'>{{ $t('nav.aboutTitle') }}</a>
              </div>
              <em class="arr" @click.prevent="toggleMobileNav(6)"><i class="iconfont iconxjt"></i></em>
            </span>
            <div class="NavPulls" :class="{ open: mobileNavOpen === 6 }">
              <dl>

                <dd><a href='/AboutWe#about'>{{ $t('nav.about.intro') }}</a></dd>
                <dd><a href='/AboutWe#team'>{{ $t('nav.about.team') }}</a></dd>
                <dd><a href='/AboutWe#parent'>{{ $t('nav.about.partners') }}</a></dd>
                <dd><a href='/AboutWe'>{{ $t('nav.about.join') }}</a></dd>

              </dl>
            </div>
          </li>
        </ul>

        <div class="NavPullbg" id="menu"
          :class="{ show: navPullVisible }"
          @mouseenter="onNavPullEnter"
          @mouseleave="onNavPullLeave">
          <div class="NavPull auto" :class="{ active: activeNavPull === 0 }" style="height: 60px;">

            <div class="item">
              <h1><a href='/Technical1'>{{ $t('nav.tech.biomimetic') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href='/Technical2'>{{ $t('nav.tech.micelle') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href='/Technical3'>{{ $t('nav.tech.conjugate') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href='/Technical4'>{{ $t('nav.tech.fluorescent') }}</a></h1>
            </div>
          </div>

          <div class="NavPull auto" :class="{ active: activeNavPull === 1 }">
            <div class="item">
              <h1><a href="/LayList?index=1">{{ $t('nav.products.dye') }}</a></h1>
              <h1><a href="/LayList?index=13">{{ $t('nav.products.liposome') }}</a></h1>

            </div>

            <div class="item">
              <h1><a href="/LayList?index=2">{{ $t('nav.products.ortho') }}</a></h1>
              <h1><a href="/LayList?index=15">{{ $t('nav.products.hydrogel') }}</a></h1>
            </div>


            <div class="item">
              <h1><a href="/LayList?index=3">{{ $t('nav.products.lipid') }}</a></h1>
              <h1><a href="/LayList?index=27">{{ $t('nav.products.enzyme') }}</a></h1>
            </div>


            <div class="item">
              <h1><a href="/LayList?index=4">{{ $t('nav.products.degradable') }}</a></h1>

            </div>


            <div class="item">
              <h1><a href="/LayList?index=11">{{ $t('nav.products.microsphere') }}</a></h1>


            </div>

          </div>

          <!-- <div class="NavPull auto">
            <div class="item">
              <h1><a href="/AboutWe">物质合成</a></h1>
            </div>

            <div class="item">
              <h1><a href="/AboutWe">纳米组装</a></h1>
            </div>

            <div class="item">
              <h1><a href="/AboutWe">生物医学成像</a></h1>
            </div>

            <div class="item">
              <h1><a href="/AboutWe">多模式疾病干预与病理学分析</a></h1>
            </div>

            <div class="item">
              <h1><a href="/AboutWe">高端物质结构解析</a></h1>
            </div>
          </div> -->
          <div class="NavPull auto" :class="{ active: activeNavPull === 2 }">
            <div class="item">
              <h1><a href="/Peptide">{{ $t('nav.service.peptide') }}</a></h1>
              <h1><a href="/PNA">{{ $t('nav.service.pna') }}</a></h1>
              <h1><a href="/Protein">{{ $t('nav.service.protein') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href="/OligonucleotideSynthesis">{{ $t('nav.service.oligo') }}</a></h1>
              <h1><a href="/CouplingLabeling">{{ $t('nav.service.conjugation') }}</a></h1>
              <h1><a href="/AntibodyDrugconJugate">{{ $t('nav.service.adc') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href="/Customization">{{ $t('nav.service.nanomaterial') }}</a></h1>
              <h1><a href="/CellMembraneExtraction">{{ $t('nav.service.membrane') }}</a></h1>

            </div>

            <div class="item">
              <h1><a href="/Exosomes">{{ $t('nav.service.exosome') }}</a></h1>
              <h1><a href="/LNPprotein">{{ $t('nav.service.lnp') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href="/ProteinCrystalStructure">{{ $t('nav.service.crystal') }}</a></h1>
              <h1><a href="/IsotopeCompounds">{{ $t('nav.service.isotope') }}</a></h1>
            </div>
          </div>




          <div class="NavPull auto" :class="{ active: activeNavPull === 3 }" style="height: 60px;">

            <div class="item">
              <h1><a href='/DownList?index=0'>{{ $t('nav.downloads.sciInfo') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href='/DownList?index=1'>{{ $t('nav.downloads.orderInfo') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href='/DownList?index=2'>{{ $t('nav.downloads.techDoc') }}</a></h1>
            </div>
          </div>

          <div class="NavPull auto" :class="{ active: activeNavPull === 4 }" style="height: 0px;">
          </div>

          <div class="NavPull auto" :class="{ active: activeNavPull === 5 }" style="height: 60px;">

            <div class="item">
              <h1><a href='/AboutWe#about'>{{ $t('nav.about.intro') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href='/AboutWe#team'>{{ $t('nav.about.team') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href='/AboutWe#parent'>{{ $t('nav.about.partners') }}</a></h1>
            </div>

            <div class="item">
              <h1><a href='/AboutWe'>{{ $t('nav.about.join') }}</a></h1>
            </div>

          </div>



        </div>
      </div>

      <div class="TopSearch">
        <div class="Searchico" :class="{ on: searchOpen }" @click="toggleSearch">
          <i class="iconfont iconso"></i>
          <i class="iconfont icongb"></i>
        </div>
        <div class="searchbox" :class="{ on: searchOpen }">
          <!-- <input type="text" name="textfield" id="key" class="input" placeholder="搜索"> -->
          <el-input v-model="searchQuery" type="text" name="textfield" id="key" class="input" :placeholder="$t('nav.search.placeholder')"
            clearable @keyup.enter="handleSearch"></el-input>
          <!-- <button class="btn" id="subm" type="button"><i class="iconfont iconso"></i></button> -->
          <el-button class="btn" id="subm" type="button" @click="handleSearch"><el-icon>
              <Search />
            </el-icon></el-button>
          <!-- 添加搜索结果列表 -->
          <div v-if="searchResults.length > 0" class="search-results">
            <el-card v-for="(result, index) in searchResults" :key="index" class="search-result-card">
              <div class="search-result-content">
                <div class="result-title">
                  <el-link :href="result.link" type="primary">
                    {{ result.title }}
                  </el-link>
                  <el-tag size="small">{{ result.category }}</el-tag>
                </div>
                <div class="result-description">{{ result.description }}</div>

              </div>
            </el-card>
          </div>
          <div v-else-if="hasSearched" class="no-results">
            {{ $t('nav.search.noResults') }}
          </div>
        </div>
      </div>

      <div class="nav">
        <LangSwitcher />
        <div v-if="!authStore.isLoggedIn">
          <a href="javascript:;" class="wxLogin" @click="goLogin"><img src="static/picture/cart.png"><i>{{ $t('nav.cart') }}</i></a>
        </div>
        <div v-else>
          <div class="cart1" type="primary" @click="cartVisible = true">

            <img style="width: 20px;" src="static/picture/cart.png" class="white">
            <img style="width: 20px;" src="static/picture/cartlan.png" class="caise">
            <i class="iconfont iconcart"></i>{{ $t('nav.cart') }}
            <div class="cart-count-box">
              <span class="cart-count">{{ cartStore.cartCount }}</span>
            </div>
          </div>
        </div>

        <div class="loginInfo">
          <div class="fm-phone-a" v-if="!authStore.isLoggedIn">
            <a href="/Login" class="login-btn">
              <i class="iconfont iconuser"></i>{{ $t('nav.login') }}
            </a>
          </div>

          <div class="cart1" v-else>

            <!-- <a :href="getHref" class="a_name">
               -->

            <a v-if="authStore.isAdmin"  href="/AdminCenter" class="a_name">
              <img style="width: 20px;" src="static/picture/userweight.png" class="white">
              <img style="width: 20px;" src="static/picture/userblue.png" class="caise">
              <i class="userName iconcart">
                {{ $t('nav.adminPrefix') }}{{ authStore.username }}
              </i>
            </a>
            <a v-else href="/MemberCenter" class="a_name">
              <img style="width: 20px;" src="static/picture/userweight.png" class="white">
              <img style="width: 20px;" src="static/picture/userblue.png" class="caise">
              <i class="userName iconcart">
                {{ $t('nav.userPrefix') }}{{ authStore.username }}
              </i>
            </a>
            <a href="javascript:;" @click="authStore.logoutAction" class="loginOut">
              {{ $t('nav.logout') }}
            </a>
          </div>

        </div>
      </div>
    </div>

    <div class="openbtn" :class="{ on: mobileMenuOpen }" @click="toggleMobileMenu">
      <span class="sp1">
      </span><span class="sp2">
      </span><span class="sp3">
      </span>
    </div>
    <div class="closebtn" :style="{ display: mobileMenuOpen ? 'block' : 'none' }" @click="closeMobileMenu"></div>
    <div class="clear"></div>


    <!-- 引入购物车组件 -->
    <Cart v-model:visible="cartVisible" />

    <!-- 使用 Element Plus 的 el-dialog 组件 -->
    <!-- <el-dialog 
      title="搜索结果" 
      v-model:visible="showSearchDialog" 
      width="50%" 
      @close="handleClose"
    >
      <el-input 
        v-model="searchQuery" 
        placeholder="请输入搜索内容" 
        clearable
        @keyup.enter="handleSearch"
      ></el-input>
      
      <div v-if="searchResults.length > 0" class="search-results">
        <el-list>
          <el-list-item v-for="(result, index) in searchResults" :key="index">
            <el-link :href="result.link" type="primary">
              {{ result.title }}
            </el-link>
          </el-list-item>
        </el-list>
      </div>
      <div v-else-if="hasSearched" class="no-results">
        未找到相关内容
      </div>
      
      <template #footer>
        <el-button @click="showSearchDialog = false">关闭</el-button>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </template>
</el-dialog> -->
  </header>
</template>

<script>
import { useAuthStore } from '../store/index'
import { useCartStore } from '../store/cartStore'
import { ElMessage } from 'element-plus'
import { Search } from '@element-plus/icons-vue'

import Cart from "./productList/Cart.vue";
import LangSwitcher from "./LangSwitcher.vue";
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
  name: 'vueHeader',
  methods: {
  },
  components: { Cart, Search, LangSwitcher },
  data() {
    return {
      cartVisible: false, // 控制购物车弹窗的显示
    };
  },
  setup() {
    const { t, tm } = useI18n();
    const authStore = useAuthStore();
    const cartStore = useCartStore();
    const showSearchDialog = ref(false);
    const searchQuery = ref('');
    const searchResults = ref([]);
    const hasSearched = ref(false);

    // --- 搜索框 toggle ---
    const searchOpen = ref(false);
    function toggleSearch() {
      searchOpen.value = !searchOpen.value;
      if (searchOpen.value) {
        mobileMenuOpen.value = false;
      }
    }

    // --- PC 导航下拉 (hover) ---
    const navHoverIndex = ref(-1);
    const navPullVisible = ref(false);
    const activeNavPull = ref(-1);
    const navPullHovered = ref(false); // 鼠标是否在下拉面板上

    function onNavHover(index) {
      navHoverIndex.value = index;
      navPullHovered.value = false;
      if (window.innerWidth > 1024) {
        activeNavPull.value = index - 1;
        navPullVisible.value = true;
      }
    }

    function onNavLeave() {
      navHoverIndex.value = -1;
      if (window.innerWidth > 1024) {
        setTimeout(() => {
          // 鼠标已经移到面板上就不关闭
          if (navHoverIndex.value === -1 && !navPullHovered.value) {
            navPullVisible.value = false;
            activeNavPull.value = -1;
          }
        }, 200);
      }
    }

    function onNavPullEnter() {
      navPullHovered.value = true;
    }

    function onNavPullLeave() {
      navPullHovered.value = false;
      navPullVisible.value = false;
      activeNavPull.value = -1;
    }

    // --- 移动端导航 (click arr) ---
    const mobileNavOpen = ref(-1);
    function toggleMobileNav(index) {
      if (window.innerWidth <= 1024) {
        mobileNavOpen.value = mobileNavOpen.value === index ? -1 : index;
      }
    }

    // --- 移动端汉堡菜单 ---
    const mobileMenuOpen = ref(false);
    function toggleMobileMenu() {
      mobileMenuOpen.value = !mobileMenuOpen.value;
      document.body.classList.toggle('bodyon', mobileMenuOpen.value);
    }
    function closeMobileMenu() {
      mobileMenuOpen.value = false;
      mobileNavOpen.value = -1;
      document.body.classList.remove('bodyon');
    }

    // --- 滚动 Header 固定 ---
    // headerEl ref 不再需要，使用 querySelector
    function handleScroll() {
      const header = document.querySelector('.Header');
      if (!header) return;
      const scrTop = window.scrollY;
      if (scrTop === 0) {
        header.classList.remove('fixed3', 'fixed2');
      } else if (scrTop < 100) {
        header.classList.remove('fixed3');
        header.classList.add('fixed2');
      } else {
        const prev = header.dataset.prev || 0;
        if (Number(prev) < scrTop) {
          // 下滚 → 隐藏
          header.classList.remove('fixed2');
          header.classList.add('fixed3');
        } else {
          // 上滚 → 显示
          header.classList.remove('fixed3');
          header.classList.add('fixed2');
        }
        header.dataset.prev = scrTop;
      }
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll, { passive: true });
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    // --- 返回顶部 ---
    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // --- 未登录购物车 → 跳转登录 ---
    const router = useRouter();
    function goLogin() {
      router.push('/Login');
    }
    // // 动态计算 href 
    // const getHref = computed(() => {
    //   return authStore.isAdmin  ? '/AdminCenter' : '/MemberCenter';
    // });
 
    // 定义搜索范围内的内容

    // 搜索数据 — 从 i18n locale 读取
    const searchableLinks = [
      '/Technical1', '/Technical2', '/Technical3', '/Technical4',
      '/LayList?index=1', '/LayList?index=2', '/LayList?index=3', '/LayList?index=4',
      '/LayList?index=11', '/LayList?index=13', '/LayList?index=15',
      '/LayList?index=15', '/LayList?index=15', '/LayList?index=15',
      '/LayList?index=15', '/LayList?index=15', '/LayList?index=15',
      '/LayList?index=15', '/LayList?index=15', '/LayList?index=15',
      '/LayList?index=15', '/LayList?index=15', '/LayList?index=15',
      '/LayList?index=15', '/LayList?index=15', '/LayList?index=15',
      '/LayList?index=13', '/LayList?index=13', '/LayList?index=13',
      '/LayList?index=11', '/LayList?index=11',
      '/LayList?index=4', '/LayList?index=4', '/LayList?index=4',
    ];
    const searchableContent = computed(() => {
      const items = tm('search.items');
      return items.map((item, i) => ({
        title: item.title,
        description: item.description,
        link: searchableLinks[i] || '/',
        category: i < 4 ? t('search.category.tech') :
                  i < 11 ? t('search.category.products') :
                  i < 25 ? t('search.category.hydrogel') :
                  i < 28 ? t('search.category.liposome') :
                  i < 31 ? t('search.category.microsphere') :
                  t('search.category.degradable')
      }));
    });


    const handleSearch = () => {
      if (!searchQuery.value || searchQuery.value.trim() === '') {
        ElMessage.warning(t('search.enterKeyword'));
        return;
      }

      hasSearched.value = true;
      // const query = searchQuery.value.toLowerCase().trim();

      // // 执行搜索
      // searchResults.value = searchableContent.filter(item =>
      //   item.title.toLowerCase().includes(query)
      // );

      // 将搜索词分割成数组并去除空格
      const queryWords = searchQuery.value.toLowerCase().trim().split(/\s+/);

      // 执行搜索 - 检查标题和描述是否包含任意搜索词
      searchResults.value = searchableContent.value.filter(item => {
        const titleLower = item.title.toLowerCase();
        // const descriptionLower = item.description.toLowerCase();

        // 如果任何一个搜索词在标题或描述中出现,就返回true
        return queryWords.some(word =>
          titleLower.includes(word)
          //  || descriptionLower.includes(word)
        );
      });
    };

    const handleClose = () => {
      searchQuery.value = '';
      searchResults.value = [];
      hasSearched.value = false;
    };

    return {
      authStore,
      cartStore,
      showSearchDialog,
      searchQuery,
      searchResults,
      hasSearched,
      handleSearch,
      handleClose,
      // search toggle
      searchOpen,
      toggleSearch,
      // PC nav dropdown
      navHoverIndex,
      navPullVisible,
      activeNavPull,
      onNavHover,
      onNavLeave,
      onNavPullEnter,
      onNavPullLeave,
      // mobile nav
      mobileNavOpen,
      toggleMobileNav,
      // mobile menu
      mobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu,
      // scroll top
      scrollToTop,
      // cart login redirect
      goLogin,
      // getHref,
      addToCart: cartStore.addToCart,
    }
  }




};
</script>

<style scoped>

.login-btn {
  display: inline-flex;
  align-items: center;
  margin-left: 15px;
  color: #333;
  font-size: 14px;
}

.login-btn i {
  margin-right: 5px;
  font-size: 16px;
}

.login-btn:hover {
  color: #005fc5;
}

/* 防止用户名过长导致换行 */
.nav .a_name {
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex !important;
  align-items: center;
}

.nav .userName {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  display: inline-block;
}

/* .cart1 {
  display: flex;
  align-items: center;
  margin-left: 10px;
  position: relative;
  color: white; 
} */

.iconcart {
  font-size: 18px;
  margin-right: 5px;
}

/* .cart-count-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: black;
  border-radius: 5px; 
  width: 24px;       
  height: 24px;       
  margin-left: 8px;   
} */

.cart-count {
  font-size: 14px;
  font-weight: bold;
  /* 数字加粗 */
}

/*.item {
//  margin-top: 10px;
//  margin-right: 30px;
}*/

.search-results {
  margin-top: 20px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
}

.search-result-card {
  margin-bottom: 15px;
  transition: all 0.3s;
}

.search-result-card:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  transform: translateY(-2px);
}

.search-result-content {
  padding: 10px;
}

.result-title {
  font-size: 16px;
  margin-bottom: 8px;
}

.result-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
  line-height: 1.4;
}

.result-category {
  margin-top: 5px;
}

.no-results {
  margin-top: 20px;
  text-align: center;
  color: #909399;
}

/* === Vue-native nav dropdown (替代 jQuery common.js) === */

/* PC 下拉面板 */
.NavPullbg.show {
  display: block !important;
}
/* NavPull 用 display:block 而非 flex，保持原 text-align:center 居中 */
.NavPull.auto {
  display: none;
}
.NavPull.auto.active {
  display: block;
}

/* 移动端：汉堡菜单展开时显示 MainNav */
@media (max-width: 1024px) {
  .MainNav.on {
    display: block !important;
  }
  /* 移动端内嵌导航展开 */
  .NavPulls {
    display: none;
  }
  .NavPulls.open {
    display: block;
  }
}
</style>